// extracted by mini-css-extract-plugin
export default {"wrapper":"Input_wrapper__-KjgZ","container":"Input_container__GU9Zx","input":"Input_input__ISje6","icon":"Input_icon__Kpmk1","error":"Input_error__z6JQo"};